"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmallButton = exports.Icon = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
const Icon = exports.Icon = (0, _mui.styled)('span')(({
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.default.dark,
  borderRadius: '50%',
  color: theme.palette.default.contrastText,
  display: 'flex',
  fontSize: '2.4rem',
  justifyContent: 'center',
  padding: 6,
  transition: theme.transitions.create(['background-color'], {
    duration: theme.transitions.duration.short
  })
}));
const SmallButton = exports.SmallButton = (0, _mui.styled)(_checkoutUi.MiniButton)({
  alignSelf: 'end',
  position: 'absolute'
});